var Shopify = Shopify || {}

Shopify.money_format = '${{amount}}'
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '')
  }
  let value = ''
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  const formatString = format || this.money_format

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : ''

    return dollars + cents
  }

  if (formatString.match(placeholderRegex)[1]) {
    value = formatWithDelimiters(cents, 2)
  }

  return formatString.replace(placeholderRegex, value)
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  )
}

class SectionId {
  static #separator = '__'

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0]
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1]
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent))

    const newNodeWrapper = document.createElement('div')
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML)
    const newNode = newNodeWrapper.firstChild

    // dedupe IDs
    const uniqueKey = Date.now()
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`)
      element.form &&
        element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`)
    })

    oldNode.parentNode.insertBefore(newNode, oldNode)
    oldNode.style.display = 'none'

    postProcessCallbacks?.forEach((callback) => callback(newNode))

    setTimeout(() => oldNode.remove(), 500)
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script')
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      })
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML))
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag)
    })
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button')
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'))

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open'),
    )
  })

  if (summary.closest('header-drawer, menu-drawer')) return
  summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length)
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible')
} catch (e) {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ]
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener('mousedown', (event) => {
    mouseClick = true
  })

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused')

      if (mouseClick) return

      currentFocusedElement = document.activeElement
      currentFocusedElement.classList.add('focused')
    },
    true,
  )
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*',
    )
  })
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach((video) => video.pause())
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.setAttribute('aria-expanded', false)
  summaryElement.focus()
}

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })
    this.input.addEventListener('change', this.onInputChange.bind(this))
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    )
  }

  quantityUpdateUnsubscriber = undefined

  connectedCallback() {
    this.validateQtyRules()
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    )
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber()
    }
  }

  onInputChange(event) {
    this.validateQtyRules()
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min
      } else {
        this.input.stepUp()
      }
    } else {
      this.input.stepDown()
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min)
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value)
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']")
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min))
    }
    if (this.input.max) {
      const max = parseInt(this.input.max)
      const buttonPlus = this.querySelector(".quantity__button[name='plus']")
      buttonPlus.classList.toggle('disabled', value >= max)
    }
  }
}

customElements.define('quantity-input', QuantityInput)

function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function throttle(fn, delay) {
  let lastCall = 0
  return function (...args) {
    const now = new Date().getTime()
    if (now - lastCall < delay) {
      return
    }
    lastCall = now
    return fn(...args)
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid)

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this))

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super()

    this.mainDetailsToggle = this.querySelector('details')

    this.addEventListener('keyup', this.onKeyUp.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.bindEvents()
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this)),
    )
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)',
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)))
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const parentMenuElement = detailsElement.closest('.has-submenu')
    const isOpen = detailsElement.hasAttribute('open')
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'))
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus)
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement)

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening')
        summaryElement.setAttribute('aria-expanded', true)
        parentMenuElement && parentMenuElement.classList.add('submenu-open')
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus)
      }, 100)
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })
    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    this.closest('.shopify-section').classList.add('menu-drawer-opened')
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return

    this.mainDetailsToggle.classList.remove('menu-opening')
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open')
      details.classList.remove('menu-opening')
    })
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open')
    })
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
    this.closest('.shopify-section').classList.remove('menu-drawer-opened')
    removeTrapFocus(elementToFocus)
    this.closeAnimation(this.mainDetailsToggle)

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false)
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer()
    })
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details')
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open')
    parentMenuElement && parentMenuElement.classList.remove('submenu-open')
    detailsElement.classList.remove('menu-opening')
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false)
    removeTrapFocus(detailsElement.querySelector('summary'))
    this.closeAnimation(detailsElement)
  }

  closeAnimation(detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute('open')
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary'),
          )
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header')
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
        ? 1
        : 0
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    )
    this.header.classList.add('menu-open')

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })

    summaryElement.setAttribute('aria-expanded', true)
    window.addEventListener('resize', this.onResize)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return
    super.closeMenuDrawer(event, elementToFocus)
    this.header.classList.remove('menu-open')
    window.removeEventListener('resize', this.onResize)
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      )
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
  }
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false))
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model'))
          this.hide()
      })
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide()
      })
    }
  }

  connectedCallback() {
    if (this.moved) return
    this.moved = true
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '')
    document.body.appendChild(this)
  }

  show(opener) {
    this.openedBy = opener
    const popup = this.querySelector('.template-popup')
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    if (popup) popup.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
    window.pauseAllMedia()
  }

  hide() {
    document.body.classList.remove('overflow-hidden')
    document.body.dispatchEvent(new CustomEvent('modalClosed'))
    this.removeAttribute('open')
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()
  }
}
customElements.define('modal-dialog', ModalDialog)

class BulkModal extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0]
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html')
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode
            this.innerHTML = sourceQty.innerHTML
          })
          .catch((e) => {
            console.error(e)
          })
      }
    }

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`),
    )
  }
}

customElements.define('bulk-modal', BulkModal)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    const button = this.querySelector('button')

    if (!button) return
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'))
      if (modal) modal.show(button)
    })
  }
}
customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    const poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (!poster) return
    poster.addEventListener('click', this.loadContent.bind(this))
  }

  loadContent(focus = true) {
    window.pauseAllMedia()
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

      this.setAttribute('loaded', true)
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'))
      if (focus) deferredElement.focus()
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play()
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style')
      deferredElement.setAttribute('style', 'display: block;')
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle)
      }, 0)
    }
  }
}

customElements.define('deferred-media', DeferredMedia)

if (!customElements.get('rebuilt-product-card')) {
  class RebuiltProductCard extends HTMLElement {
    abortController = null
    isEffectActive = false

    constructor() {
      super()
    }

    connectedCallback() {
      this.moneyPrefix = this.dataset.moneyPrefix || ''
      this.init()
      this.openQuickAddModal()
      this.addEventListener('change', this.onChangeSwatch.bind(this))
      // Check if the product card should redirect to the product page or open the quick add modal
      const shouldRedirect = this.dataset.shouldRedirect === 'true'
      if (shouldRedirect) {
        this.clickAnchor()
      } else {
        this.interceptAnchorClick()
      }
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChangeSwatch.bind(this))
    }

    async onChangeSwatch(event) {
      const target = event.target
      const productUrl = target.value

      const productJson = await this.fetchProductAndUpdateGallery(productUrl)
      this.updateCardContent(target, productJson)
      this.updateWishlistButton(target, productJson)
    }

    checkForFavoriteButton() {}

    init() {
      if (this.dataset.disableSwiper === 'true') return
      const swiperElement = this.querySelector('.js-swiper')
      const swiperPagination = this.querySelector('.swiper-pagination')

      if (!swiperElement) return

      this.swiper = new Swiper(swiperElement, {
        direction: 'horizontal',
        slidesPerView: 1,
        loop: false,
        pagination: {
          el: swiperPagination,
          type: 'progressbar',
        },
      })

      if (Number(this.dataset.index) === 0) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.startSliderEffect()
                this.observer.unobserve(this)
              }
            })
          },
          {
            threshold: 1,
          },
        )

        this.observer.observe(this)
      }
    }

    async fetchProductAndUpdateGallery(url) {
      this.abortController?.abort()
      this.abortController = new AbortController()

      this.querySelector('.js-loading-spinner').style.display = 'block'
      this.querySelector('.rebuilt-product-card__inner-wrapper').classList.add('loading')

      try {
        const response = await fetch(url, {
          signal: this.abortController.signal,
        })

        if (!response.ok) {
          throw new Error(`Failed to fetch product page: HTTP error ${response.status}`)
        }

        const responseJson = await response.json()

        let media = [...responseJson.media]

        if (this.dataset.useSecondImage === 'true') {
          // Swap the first and second images if there are at least 2 images
          if (media.length >= 2) {
            const temp = media[0]
            media[0] = media[1]
            media[1] = temp
          }
        }

        const tags = responseJson.tags
        // const title = responseJson.title
        const productUrl = `/products/${responseJson.handle}`

        // this.productTitle.textContent = title
        this.productLink.href = productUrl

        if (
          tags.includes('Final Sale') ||
          tags.includes('finalsale') ||
          tags.includes('final-sale')
        ) {
          this.dataset.isClearance = true
        } else {
          this.dataset.isClearance = false
        }

        // Update content by replacing the swiper-wrapper innerHTML
        const swiperWrapper = this.querySelector('.swiper-wrapper')
        if (swiperWrapper) {
          // Create new slides HTML
          const slidesHtml = media
            .map(
              (image) => `
            <div class="swiper-slide">
              <a href="${productUrl}" class="rebuilt-product-card__media-wrapper">
                <img src="${image.src}&width=500" alt="${image.alt}" loading="lazy" width="258" height="328" />
              </a>
            </div>
          `,
            )
            .join('')

          // Replace the wrapper content
          swiperWrapper.innerHTML = slidesHtml
        }

        // Update swiper to reflect changes
        if (this.swiper) {
          this.swiper.update()
        }

        return responseJson
      } catch (error) {
        if (error.name === 'AbortError') {
          return
        } else {
          throw error
        }
      } finally {
        this.abortController = null
        this.querySelector('.rebuilt-product-card__inner-wrapper').classList.remove('loading')
        this.querySelector('.js-loading-spinner').style.display = 'none'
      }
    }

    updateCardContent(target, productJson) {
      const productPrice = Number(target.dataset.productPrice)
      const productCompareAtPrice = Number(target.dataset.productCompareAtPrice)
      const productFormattedPrice = target.dataset.productFormattedPrice
      const productFormattedCompareAtPrice = target.dataset.productFormattedCompareAtPrice
      const productSavingsPercentage = Number(target.dataset.productSavingsPercentage)
      const productFormattedSavingsAmount = target.dataset.productFormattedSavingsAmount
      const discountText = target.dataset.discountText

      const isMostLiked = target.dataset.tagMostLiked === 'true'
      const isSecondMostLiked = target.dataset.tagSecondMostLiked === 'true'
      const isNewArrival = target.dataset.tagNewArrival === 'true'

      this.productPrice.textContent = productFormattedPrice
      this.productCompareAtPrice.textContent = productFormattedCompareAtPrice
      if (Number(this.discountPromoBadge.dataset.discountPercentage) > 0) {
        this.discountPromoBadge
          .closest('.rebuilt-product-card__discount-box-wrapper')
          ?.classList.add('active')
      } else {
        this.discountPromoBadge
          .closest('.rebuilt-product-card__discount-box-wrapper')
          ?.classList.remove('active')
      }
      this.discountPromoBadge.textContent = discountText

      // const discountBadge = this.querySelector('.js-discount')
      const mostLikedBadge = this.querySelector('.js-most-liked')
      const secondMostLikedBadge = this.querySelector('.js-second-most-liked')
      const newArrivalBadge = this.querySelector('.js-new-arrival')

      if (this.dataset.isClearance === 'true') {
        const compareAtPriceEl = this.querySelector('.pc-clear-top__right-msrp--price')
        const savingsLabelEl = this.querySelector('.pc-clear-top__right-total-savings--label')
        const savingsAmtEl = this.querySelector('.pc-clear-top__right-total-savings--amt')
        const priceEl = this.querySelector('.pc-clear-top__right-deal--price')
        if (compareAtPriceEl !== null) {
          compareAtPriceEl.style.display = 'none'
        }
        if (savingsLabelEl !== null) {
          savingsLabelEl.style.display = 'none'
        }
        if (savingsAmtEl !== null) {
          savingsAmtEl.style.display = 'none'
        }
        if (priceEl !== null) {
          priceEl.style.display = 'none'
        }
        if (productCompareAtPrice > productPrice) {
          if (compareAtPriceEl !== null) {
            compareAtPriceEl.style.display = 'block'
            compareAtPriceEl.textContent = productFormattedCompareAtPrice
          }
          if (savingsLabelEl !== null) {
            savingsLabelEl.style.display = 'block'
            savingsLabelEl.innerHTML = `<span>total </span>savings (${productSavingsPercentage}%)`
          }
          if (savingsAmtEl !== null) {
            savingsAmtEl.style.display = 'block'
            savingsAmtEl.textContent = productFormattedSavingsAmount
          }
          if (priceEl !== null) {
            priceEl.style.display = 'block'
            priceEl.textContent = productFormattedPrice
          }
        }
      }

      if (isMostLiked) {
        mostLikedBadge.style.display = 'block'
      } else {
        mostLikedBadge.style.display = 'none'
      }

      if (isSecondMostLiked) {
        secondMostLikedBadge.style.display = 'block'
      } else {
        secondMostLikedBadge.style.display = 'none'
      }

      if (isNewArrival) {
        newArrivalBadge.style.display = 'block'
      } else {
        newArrivalBadge.style.display = 'none'
      }

      const title = productJson.title
      const productUrl = `/products/${productJson.handle}`
      const currency = target.dataset.currency

      // Update quick add button data attributes for data layer
      if (this.quickAddButton) {
        this.quickAddButton.dataset.productHref = productUrl
        this.quickAddButton.ariaLabel = `Quick add modal ${title}`
        this.quickAddButton.dataset.productId = productJson.id
        this.quickAddButton.dataset.productTitle = title
        this.quickAddButton.dataset.productVendor = productJson.vendor
        this.quickAddButton.dataset.productType = productJson.type
        this.quickAddButton.dataset.productFormattedPrice = productFormattedPrice
        this.quickAddButton.dataset.currency = currency
      }

      const secondQuickAddButton = this.querySelector('.pc-clear-bottom__quick-add')
      if (secondQuickAddButton) {
        secondQuickAddButton.dataset.productHref = productUrl
        secondQuickAddButton.ariaLabel = `Quick add modal ${title}`
        secondQuickAddButton.dataset.productId = productJson.id
        secondQuickAddButton.dataset.productTitle = title
        secondQuickAddButton.dataset.productVendor = productJson.vendor
        secondQuickAddButton.dataset.productType = productJson.type
        secondQuickAddButton.dataset.productFormattedPrice = productFormattedPrice
        secondQuickAddButton.dataset.currency = currency
      }

      this.dataset.productPrice = (productPrice / 100).toFixed(2)
      this.dataset.productTitle = title
      this.dataset.packSize = target.dataset.packSize
      this.dataset.productId = productJson.id

      const isSingle = this.dataset.packSizeNumber === '0'

      if (isSingle && this.dataset.isClearance === 'true') {
        const singleColor = target.dataset.productTitle.split(' - ')[1]
        if (this.productSingleColor && singleColor)
          this.productSingleColor.textContent = singleColor
      } else {
        if (this.productTitle) this.productTitle.textContent = target.dataset.productTitle
      }
    }

    startSliderEffect() {
      if (this.isEffectActive) return

      this.isEffectActive = true

      this.swiper.slideTo(1, 400)
      this.swiper.setTranslate(-100)

      this.swiper.on('transitionEnd', () => {
        if (this.isEffectActive) {
          this.swiper.slideTo(0, 150)
          this.isEffectActive = false
        }
      })
    }

    openQuickAddModal() {
      this.addEventListener('click', (event) => {
        const quickAddBadge = event.target.closest('a.badge__link')
        if (quickAddBadge) {
          event.preventDefault()
          this.quickAddButton.click()
        }
      })
    }

    interceptAnchorClick() {
      this.addEventListener('click', (event) => {
        // Check if the clicked element is an anchor or is inside an anchor
        const anchor = event.target.closest('a:not(.badge__link)')
        if (anchor) {
          if (anchor.dataset.type === 'gift-card') {
            return
          }
          event.preventDefault()
          this.quickAddButton.click()
        }
      })
    }

    clickAnchor() {
      this.addEventListener('click', (event) => {
        // Check if clicked element is an anchor or is inside an anchor
        const anchor = event.target.closest('a:not(.badge__link)')
        if (anchor) {
          const dataObject = {
            event: 'select_item',
            membership_status: this.dataset.membershipStatus,
            ...window.intelligemsMeta,
            userId: this.dataset.customerId || null,
            login_status: this.dataset.loginStatus,
            page_type: this.dataset.pdpType,
            ecommerce: {
              item_list_id: this.dataset.collectionId,
              item_list_name: this.dataset.collectionTitle,
              currency: this.dataset.ecommerceCurrency,
              items: [
                {
                  item_id: this.dataset.productId,
                  item_name: this.dataset.productTitle,
                  coupon: '',
                  discount: this.dataset.productDiscount,
                  index: Number(this.dataset.index) + 1,
                  item_brand: this.dataset.productBrand,
                  item_category: this.dataset.productCategory1,
                  item_category2: this.dataset.productCategory2,
                  item_category3: this.dataset.productCategory3,
                  item_category4: '',
                  item_category5: this.dataset.productCategory5,
                  item_list_id: this.dataset.collectionId,
                  item_list_name: this.dataset.collectionTitle,
                  item_variant: this.dataset.colorPack,
                  price: this.dataset.productPrice,
                  quantity: 1,
                },
              ],
            },
          }
          window.dataLayer = window.dataLayer || []
          dataLayer.push({ ecommerce: null })
          dataLayer.push(dataObject)
        }
      })
    }

    async updateWishlistButton(target, productJson) {
      const rivoFavoriteButton = this.querySelector('rivo-favorite-button')
      if (!rivoFavoriteButton) return
      rivoFavoriteButton.dataset.productId = productJson.id
      rivoFavoriteButton.dataset.variantId = ''

      rivoFavoriteButton.classList.remove('rivo-favorite-active')
      if (
        typeof RivoProfileAlpine !== 'undefined' &&
        typeof RivoProfileAlpine.store('rivo_favorite_products') !== 'undefined'
      ) {
        const favorite = RivoProfileAlpine.store('rivo_favorite_products').find(
          (item) => item.product_id === productJson.id.toString(),
        )
        if (favorite) {
          rivoFavoriteButton.classList.add('rivo-favorite-active')
        }
      }
    }

    get wishlistButton() {
      return this.querySelector('rivo-favorite-button')
    }

    get productTitle() {
      return this.querySelector('.js-product-title')
    }

    get productSingleTitle() {
      return this.querySelector('.js-product-single-title')
    }

    get productSingleColor() {
      return this.querySelector('.js-product-single-color')
    }

    get productLink() {
      return this.querySelector('.js-product-link')
    }

    get productPrice() {
      return this.querySelector('.js-product-price')
    }

    get productCompareAtPrice() {
      return this.querySelector('.js-product-compare-at-price')
    }

    get productTotalSavingsLabel() {
      return this.querySelector('.js-product-total-savings-label')
    }

    get productTotalSavingsAmt() {
      return this.querySelector('.js-product-total-savings-amt')
    }

    get quickAddButton() {
      return this.querySelector('quick-add-button')
    }

    get discountPromoBadge() {
      return this.querySelector('.js-price-with-active-promo')
    }
  }

  customElements.define('rebuilt-product-card', RebuiltProductCard)
}

class AccountIcon extends HTMLElement {
  constructor() {
    super()

    this.icon = this.querySelector('.icon')
  }

  connectedCallback() {
    document.addEventListener(
      'storefront:signincompleted',
      this.handleStorefrontSignInCompleted.bind(this),
    )
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode())
    }
  }
}

customElements.define('account-icon', AccountIcon)

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250

  constructor() {
    super()
    this.queue = []
    this.setRequestStarted(false)
    this.ids = []
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity })

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue)
        }
      } else {
        clearInterval(interval)
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY)
  }

  sendRequest(queue) {
    this.setRequestStarted(true)
    const items = {}

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity
    })
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement))

    this.updateMultipleQty(items)
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted
  }

  get requestStarted() {
    return this._requestStarted
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`)
    input.value = input.getAttribute('value')
    this.isEnterPressed = false
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message)
    event.target.reportValidity()
    this.resetQuantityInput(index)
    event.target.select()
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value)
    const index = event.target.dataset.index

    if (inputValue < event.target.dataset.min) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min),
      )
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.max_error.replace('[max]', event.target.max),
      )
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.step_error.replace('[step]', event.target.step),
      )
    } else {
      event.target.setCustomValidity('')
      event.target.reportValidity()
      event.target.setAttribute('value', inputValue)
      this.startQueue(index, inputValue)
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd)
}

class CartPerformance {
  static #metric_prefix = 'cart-performance'

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`)
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp,
    })

    const endMarker = performance.mark(`${metricName}:end`)

    performance.measure(benchmarkName, `${metricName}:start`, `${metricName}:end`)
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`)

    performance.measure(benchmarkName, startMarker.name, `${metricName}:end`)
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`)

    callback()

    const endMarker = performance.mark(`${metricName}:end`)

    performance.measure(benchmarkName, `${metricName}:start`, `${metricName}:end`)
  }
}

// For global use
async function openQuickAddModal(handle, dataAttributes = []) {
  const modal = document.querySelector('quick-modal')
  if (!modal) return
  if (dataAttributes.length > 0) {
    dataAttributes.forEach((attribute) => {
      modal.setAttribute(`data-${attribute.key}`, attribute.value)
    })
  }
  modal.dataset.productHref = window.Shopify?.routes?.root + 'products/' + handle
  await modal.open()
}

// if announcement bar link has `open_menu=boys` in the url then open the mobile-menu and show the boys section

// Function to handle open_menu=boys links in announcement bars
function handleDepBoysAnnouncementLinks() {
  // Get all announcement bar links
  const announcementLinks = document.querySelectorAll('.new-announcement-bar__link')

  announcementLinks.forEach((link) => {
    // Remove existing listeners to prevent duplicates
    link.removeEventListener('click', link.depBoysHandler)

    // Create new handler
    link.depBoysHandler = function (e) {
      const href = this.getAttribute('href')

      // Check if the link contains open_menu=boys parameter
      if (href && href.includes('open_menu=boys')) {
        e.preventDefault()
        // Open mobile menu for boys
        openMobileMenuForBoys()
      }
    }

    // Add event listener
    link.addEventListener('click', link.depBoysHandler)
  })
}

// Function to open mobile menu and show boys section
function openMobileMenuForBoys() {
  // Check if mobile nav section exists
  const mobileNavSection = document.querySelector('.section-mobile-nav')
  if (!mobileNavSection) {
    console.warn('Mobile nav section not found')
    return
  }

  // Open mobile nav by clicking the toggle button
  const mobileNavToggle = document.getElementById('primary-nav-toggle')
  if (mobileNavToggle) {
    mobileNavToggle.click()
    console.log('mobileNavToggle clicked')
  } else {
    console.warn('Mobile nav toggle button not found')
  }

  // Wait for mobile nav to be visible and then select the boys section
  let attempts = 0
  const maxAttempts = 50 // 5 seconds max wait time

  const waitForMobileNav = () => {
    attempts++

    if (attempts > maxAttempts) {
      console.warn('Timeout waiting for mobile nav to open')
      return
    }

    const mobileNavSection = document.querySelector('.section-mobile-nav')
    if (mobileNavSection && mobileNavSection.classList.contains('active')) {
      // Mobile nav is now visible, select the boys section
      const boysRadio = document.querySelector('input[value="mobile-nav-boys"]')
      if (boysRadio) {
        boysRadio.parentElement.click()
      } else {
        console.warn('Boys radio button not found')
      }
    } else {
      // Check again in a short moment
      setTimeout(waitForMobileNav, 100)
    }
  }

  // Start waiting for mobile nav to be visible
  setTimeout(waitForMobileNav, 100)
}

// Initialize the functionality when DOM is ready
document.addEventListener('DOMContentLoaded', handleDepBoysAnnouncementLinks)

// Also check for new announcement bars that might be added dynamically
const boysAnnouncementBarObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      // Check if new announcement bar links were added
      const hasNewLinks = Array.from(mutation.addedNodes).some((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          return (
            node.querySelector('.new-announcement-bar__link') ||
            node.classList.contains('new-announcement-bar__link')
          )
        }
        return false
      })

      if (hasNewLinks) {
        setTimeout(handleDepBoysAnnouncementLinks, 100)
      }
    }
  })
})

class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts'
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 10

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId, pdpAppDataTitle = false) {
    let viewedProducts = this.getProducts()

    // Remove item with same pdpAppDataTitle if it exists
    let indexToRemove = -1
    viewedProducts.forEach((product, index) => {
      if (product.pdpAppDataTitle === pdpAppDataTitle) {
        indexToRemove = index
      }
    })
    if (indexToRemove !== -1) {
      viewedProducts.splice(indexToRemove, 1)
    }

    viewedProducts = viewedProducts.filter((product) => product.id !== productId)
    viewedProducts.unshift({
      id: productId,
      pdpAppDataTitle: pdpAppDataTitle,
    })
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS)

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts))
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY)
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]')
  }

  static getProductIds() {
    if (!localStorage.getItem(this.#STORAGE_KEY)) {
      return []
    }
    const productIds = []
    RecentlyViewed.getProducts().forEach((product) => {
      productIds.push(product.id)
    })
    return productIds
  }
}

// Start observing for dynamic content changes
if (document.body) {
  boysAnnouncementBarObserver.observe(document.body, { childList: true, subtree: true })
}

async function loadProductsFromCollection({
  collectionHandle,
  hostSectionSelector = '#main-collection-product-grid',
  productGridSelector = '#product-grid',
  productCardSelector = 'rebuilt-product-card',
  numProducts = 10,
  firstProductIndex = 0,
  replaceExistingCards = false,
  updateURL = false,
  urlParams = {},
  callback = () => {},
}) {
  if (!collectionHandle) return

  const hostSection = document.querySelector(hostSectionSelector)
  const sectionId = hostSection?.closest('.shopify-section')?.id?.replace('shopify-section-', '')
  const productGrid = hostSection?.querySelector(productGridSelector)
  if (!hostSection || !sectionId || !productGrid) return

  try {
    const url = new URL(`/collections/${collectionHandle}`, location.origin)
    url.searchParams.set('section_id', sectionId)

    const html = await fetch(url).then((r) => r.text())
    const doc = new DOMParser().parseFromString(html, 'text/html')

    const incomingGrid = doc.querySelector(productGridSelector)
    if (!incomingGrid) return

    const newCards = [...incomingGrid.querySelectorAll(productCardSelector)].slice(
      firstProductIndex,
      firstProductIndex + numProducts,
    )

    if (replaceExistingCards) productGrid.innerHTML = ''

    newCards.forEach((card) => {
      const node = document.importNode(card, true)
      const li = document.createElement('li')
      li.className = 'grid__item'
      li.appendChild(node)
      productGrid.appendChild(li)
    })

    if (updateURL) updateURLwithParams(url, urlParams)

    callback()
  } catch (err) {
    console.error('loadProductsFromCollection failed:', err)
  }
}
window.loadProductsFromCollection = loadProductsFromCollection

function updateURLwithParams(url, urlParams) {
  const localizedPath = `${window.Shopify.routes.root}${url.pathname.slice(1)}`
  const hasParams = urlParams && Object.keys(urlParams).length > 0
  const params = hasParams
    ? '?' +
      Object.entries(urlParams)
        .map(([k, v]) => `${k}=${v}`)
        .join('&')
    : ''

  history.pushState({}, '', localizedPath + params)
}
window.updateURLwithParams = updateURLwithParams

function scrollToSection(section, offset = 100) {
  const extra = window.matchMedia('(min-width: 768px)').matches ? 20 : 0

  const rect = section.getBoundingClientRect()
  const scrollTop = window.pageYOffset + rect.top - (offset + extra)
  window.scrollTo({ top: scrollTop, behavior: 'smooth' })
}
window.scrollToSection = scrollToSection

class UsoModal extends HTMLElement {
  connectedCallback() {
    const trigger = this.querySelector('.js-modal-trigger')
    if (trigger) {
      trigger.addEventListener('click', () => this.openModal())
    }
  }

  openModal() {
    const contentDiv = this.querySelector('.uso-modal-content')
    if (!contentDiv) return

    const trigger = this.querySelector('.js-modal-trigger')
    if (trigger.classList.contains('js-product-star-rating')) return

    customElements.whenDefined('dynamic-modal').then(() => {
      const DynamicModalClass = customElements.get('dynamic-modal')
      if (!DynamicModalClass || typeof DynamicModalClass.getInstance !== 'function') return

      const modal = DynamicModalClass.getInstance()
      const modalContent = modal.querySelector('.dynamic-modal__content')
      if (!modalContent) return

      modalContent.innerHTML = contentDiv.innerHTML
      modal.open()
    })
  }
}

customElements.define('uso-modal', UsoModal)

function cookieRemover(cookieNames) {
  cookieNames.forEach((cookieName) => {
    // console.log('cookieName: ', cookieName)

    const isWildcard = cookieName.includes('*')
    const prefix = isWildcard ? cookieName.replace('*', '') : null
    const paths = ['/', window.location.pathname]
    const domains = ['.trueclassictees.com', 'trueclassictees.com']

    if (isWildcard) {
      // Find all cookies matching the pattern
      const matchingCookies = document.cookie
        .split(';')
        .map((cookie) => cookie.trim())
        .filter((cookie) => cookie.startsWith(prefix))
        .map((cookie) => cookie.split('=')[0])

      matchingCookies.forEach((matchedName) => {
        // console.log('cookie found (wildcard), removing:', matchedName)
        paths.forEach((path) => {
          domains.forEach((domain) => {
            document.cookie = `${matchedName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain}`
          })
        })
      })
    } else {
      // Exact match
      if (document.cookie.split(';').some((cookie) => cookie.trim().startsWith(cookieName + '='))) {
        // console.log('cookie found, removing:', cookieName)
        paths.forEach((path) => {
          domains.forEach((domain) => {
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain}`
          })
        })
      }
    }
  })
}

window.addEventListener('DOMContentLoaded', () => {
  const cookieNames = [
    'tfc-l', // truefit
    '_vid_t',
    '2c.*', // nosto
    '_hp2_id.*', // heap
    // '_ax_visitor', // applovin/axon
    // '_ax_session_data', // applovin/axon
    // '_axwrt', // applovin/axon
    // '_ax_last_event', // applovin/axon
    '__podscribe_*', // podscribe
    'reeview_*', // videowise
    'ph_phc_*', // posthog
  ]
  cookieRemover(cookieNames)
})
